import React from 'react';
import Label from './fromLabel';
import Error from './fromError';

interface TeaxtareaProps {
    placeholder?: string;
    value: string;
    onChange: (e: any) => void;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    info?:string;
    error?:string;
}

const Textarea: React.FC<TeaxtareaProps> = ({  placeholder, value, onChange , disabled = false,label,required, info,error}) => {
    return (
        <div className='my-6 text-[0.938rem]'>
            {label && <Label text={label} required={required} info={info} />}
            <textarea
            disabled={disabled}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`pl-4 py-2 ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none text-[0.938rem] mt-2 font-normal min-h-[8.5rem] text-[#222222] placeholder:text-[#a1a1a1] w-[99%] `}
        ></textarea>
        {error && <Error message={error} />}
        </div>
        
    );
};

export default Textarea;